{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Whatsapp Predlošci",
      "SUBTITLE": "Izaberi whatsapp predložak koji želiš poslati",
      "TEMPLATE_SELECTED_SUBTITLE": "Proces {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Pretraži Predloške",
      "NO_TEMPLATES_FOUND": "Nije pronađen predložak za",
      "LABELS": {
        "LANGUAGE": "Jezik",
        "TEMPLATE_BODY": "Tijelo predloška",
        "CATEGORY": "Kategorija"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Varijable",
      "VARIABLE_PLACEHOLDER": "Unesi {variable} vrijednost",
      "GO_BACK_LABEL": "Nazad",
      "SEND_MESSAGE_LABEL": "Šalji poruku",
      "FORM_ERROR_MESSAGE": "Popuniti sve varijable prije slanja"
    }
  }
}
